import {
  CHOOSE_ADD,
  CHOOSE_ADD_YES,
  CHOOSE_ADD_NO,
  ADDRESS_LINE,
  CITY_NAME,
  COUNTRY_NAME,
  FLAT_NO,
  BUILDING_NO,
  HOUSE_NAME,
  STREET_NAME,
  AREA_NAME,
  COUNTRY_NAME_INT,
  CITY_NAME_INT,
  SELECT_ADDRESS_FIELD,
  POSTCODE_LIST_ERROR
} from './addressConstants';
import {
  REGISTER_ADDRESS_TYPE,
  PERSONAL_ADDRESS_TYPE,
  KEY_YES,
  KEY_NO
} from '../../../utils/constants';
import { isValidGlobalBehaviour } from '../../../utils/validation';

export const resetInternationAddress = (type, formValues) => {
  if (formValues[type] && formValues[type].international) {
    delete formValues[type].international[`${ADDRESS_LINE}1`];
    delete formValues[type].international[`${ADDRESS_LINE}2`];
    delete formValues[type].international[`${ADDRESS_LINE}3`];
    delete formValues[type].international[CITY_NAME_INT];
    delete formValues[type].international[COUNTRY_NAME_INT];
  }
  return formValues;
};

export const resetLocalAddress = (type, formValues) => {
  if (formValues[type] && formValues[type].local) {
    delete formValues[type].local[FLAT_NO];
    delete formValues[type].local[BUILDING_NO];
    delete formValues[type].local[HOUSE_NAME];
    delete formValues[type].local[STREET_NAME];
    delete formValues[type].local[AREA_NAME];
    delete formValues[type].local[CITY_NAME];
    delete formValues[type].local[COUNTRY_NAME];
  }
  return formValues;
};

export const resetChooseAddress = (type, formValues) => {
  let values = formValues;
  values = resetLocalAddress(type, values);
  values = resetLocalAddress(type, values);
  delete values[type][`${CHOOSE_ADD}`];
  return values;
};

export const resetSelectAddress = (type, formValues, addManuallyClicked) => {
  if (
    type !== REGISTER_ADDRESS_TYPE ||
    (type === REGISTER_ADDRESS_TYPE &&
      formValues.registerAddressSelector &&
      formValues.registerAddressSelector.toLowerCase() === KEY_NO)
  ) {
    return addManuallyClicked && formValues[type] && formValues[type][SELECT_ADDRESS_FIELD]
      ? delete formValues[type][SELECT_ADDRESS_FIELD]
      : formValues;
  }
};

export const resetRequiredFields = (addManuallyClicked, type, formValues) => {
  if (type && formValues) {
    clearLocalInternationalForms(type, formValues, addManuallyClicked);
  } else if (addManuallyClicked === false && type && formValues) {
    return delete formValues[type][CHOOSE_ADD];
  }
};

const clearLocalInternationalForms = (type, formValues, addManuallyClicked) => {
  const values = resetSelectAddress(type, formValues, addManuallyClicked);
  const field = values[type] ? values[type][CHOOSE_ADD] : '';
  if (addManuallyClicked && field && field === CHOOSE_ADD_YES) {
    return resetInternationAddress(type, values);
  } else if (
    (!addManuallyClicked && type === REGISTER_ADDRESS_TYPE) ||
    (addManuallyClicked && field && field === CHOOSE_ADD_NO)
  ) {
    return resetLocalAddress(type, values);
  }
};

export const getSelectedAddress = (formValues, type, address, dataAddress) => {
  const values = formValues[type];
  if (isPersonalAddress(address, formValues, type)) {
    return address;
  } else if (values) {
    if (values[SELECT_ADDRESS_FIELD]) {
      return values[SELECT_ADDRESS_FIELD];
    } else if (isAddressAvailable(values.local)) {
      return `${Object.values(values.local).join(', ')}${getPostCode(values)}`;
    }
    if (isAddressAvailable(values.international)) {
      return Object.values(values.international).join(', ');
    }
  }
  return type
    ? formValues[`${type}chosenAddressField`]
      ? formValues[`${type}chosenAddressField`]
      : dataAddress
    : '';
};

const getPostCode = (values) => (values && values.postcode ? `, ${values.postcode}` : '');

const isAddressAvailable = (address) => address && Object.keys(address).length > 0;

const isPersonalAddress = (address, formValues, type) =>
  (address &&
    formValues.registerAddressSelector &&
    formValues.registerAddressSelector.toLowerCase() === KEY_YES &&
    type === REGISTER_ADDRESS_TYPE) ||
  (address && type === PERSONAL_ADDRESS_TYPE);

export const postCodeFormat = (value) => {
  let postcode = value;
  postcode = postcode.toUpperCase();
  // This is a helpful little bit to automatically format a UK postcode with a space in the
  // correct spot if there isn't one already.
  const postcodeMatch = postcode.match(/^([A-Z]{1,2}\d{1,2}[A-Z]?)\s*(\d[A-Z]{2})$/);
  if (postcodeMatch !== null) {
    postcodeMatch.shift();
    postcode = postcodeMatch.join(' ');
  }
  return postcode;
};

export const isRequiredAddress = (
  value,
  name,
  isPostCodeListError,
  postCodeAddressList,
  formValues,
  isAddMunuallyClicked
) => {
  if (isValidGlobalBehaviour(value, name)) {
    if (isAddMunuallyClicked) {
      return undefined;
    }
    if (isPostCodeListError) {
      return POSTCODE_LIST_ERROR;
    }
    if (formValues && formValues.register && postCodeAddressList.length === 0) {
      return 'Required';
    }
    if (formValues && formValues.trading && postCodeAddressList.length === 0) {
      return 'Required';
    }
    if (formValues && formValues.mailing && postCodeAddressList.length === 0) {
      return 'Required';
    }
    if (postCodeAddressList && postCodeAddressList.length > 0) {
      return undefined;
    }
    return undefined;
  }
  return 'Required';
};
